import script from "./HelpButton.vue?vue&type=script&setup=true&lang=js"
export * from "./HelpButton.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__